import { render, staticRenderFns } from "./is_plug.vue?vue&type=template&id=aa2599f0&scoped=true"
import script from "./is_plug.vue?vue&type=script&lang=js"
export * from "./is_plug.vue?vue&type=script&lang=js"
import style0 from "./is_plug.vue?vue&type=style&index=0&id=aa2599f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2599f0",
  null
  
)

export default component.exports